// import { PlusCircle } from 'feather-icons-react/build/IconComponents';
import React, { useState, useEffect } from "react";
// import { Link } from 'react-router-dom';
import Select from "react-select";
import Axios from "axios";
import {
  API_BASE_URL,
  GET_VSTORE_PROD,
  INSERT_PURCHASE_REQ,
} from "../../../Config";
import Swal from "sweetalert2";
// import SupplierModal from '../peoples/supplierModal';

const AddPurchaseRequest = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [productsDDLData, setProductsDDLData] = useState([]);
  const [suppliersData, setSuppliersData] = useState([]);
  const [storesData, setStoresData] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [store, setStore] = useState("");
  const [requestDate, setRequestDate] = useState("");
  const [notes, setNotes] = useState("");
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

  // #region Session for Userdetails
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    const storesData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Stores")
    );
    const supplierData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Supplier")
    );
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      setStoresData(storesData);
      setSuppliersData(supplierData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  const initialSelectedProducts = [];

  // useEffect(() => {
  //     if (userDataSession && userDataSession.OrgId) {
  //         const requestData = {
  //             OrgId: `${userDataSession && userDataSession.OrgId}`,
  //             Id: 0,
  //             CategoryId: 0,
  //             BarCode: 0,
  //         };

  //         Axios.post(`${API_BASE_URL}${GET_PROD}`, requestData)
  //             .then((response) => {
  //                 if (response.data.Status) {
  //                     setProductsData(response.data.ResultData);
  //                 } else {
  //                     console.error("Error fetching data:", response.data.Message);
  //                 }
  //             })
  //             .catch((error) => {
  //                 console.error("Error fetching data:", error);
  //             });
  //     }
  // }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && store) {
      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: 0,
        BarCode: 0,
        ProductId: 0,
        StoreId: store,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type :1,
      };

      Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
        .then((response) => {
          if (response.data.Status) {
            console.log(response.data);
            setProductsDDLData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession, store]);

  const handleAddProduct = (selectedOption) => {
    console.log(selectedOption, "option selceted prod");
    const selectedProduct = productsDDLData.find(
      (prod) => prod.Id === selectedOption.value
    );
    console.log(selectedProduct, "s");
    if (
      selectedProducts &&
      !selectedProducts.find((prod) => prod.Id === selectedProduct.Id)
    ) {
      setSelectedProducts([
        ...selectedProducts,
        { ...selectedProduct, Quantity: "", Comments: "" },
      ]);
    }
  };

  const handleRemoveProduct = (productId) => {
    setSelectedProducts(
      selectedProducts.filter((prod) => prod.Id !== productId)
    );
  };

  const handleQuantityChange = (productId, quantity) => {
    setSelectedProducts(
      selectedProducts.map((prod) =>
        prod.Id === productId ? { ...prod, Quantity: quantity } : prod
      )
    );
  };

  const handleCommentsChange = (productId, comments) => {
    console.log(selectedProducts);
    setSelectedProducts(
      selectedProducts.map((prod) =>
        prod.Id === productId ? { ...prod, Comments: comments } : prod
      )
    );
  };

  // #region Add Purchase submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedSupplier) {
      alert("Please Select SUpplier..");
      return;
    }

    const requestPayload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      purchaserequest: {
        Id: 0,
        StoreId: store,
        SupplierId: selectedSupplier,
        RequestDate: requestDate,
        Notes: notes,
        // POStatus: "NULL"
      },
      productdetails: selectedProducts.map((prod) => ({
        detailid: 0,
        ProductId: prod.Id,
        Quantity: prod.Quantity,
        UOM: "",
        Comments: prod.Comments,
      })),
    };

    console.log(requestPayload, "data sending to service...");

    try {
      setSubmitBtnLoading(true);
      const response = await Axios.post(
        `${API_BASE_URL}${INSERT_PURCHASE_REQ}`,
        requestPayload
      );
      const data = response.data; // Axios automatically parses the JSON response

      if (data[0]["Success"] === 1) {
        setSubmitBtnLoading(false);
        Swal.fire({
          title: `Request submitted successfully.`,
          icon: "success",
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            window.location.reload();
          }
        });
      } else {
        setSubmitBtnLoading(false);
        Swal.fire({
          title: "Error",
          text: "Failed to submit request.",
          icon: "error",
        });
      }
    } catch (error) {
      setSubmitBtnLoading(false);
      console.error("Error:", error);
      Swal.fire({
        title: "Error",
        text: "An error occurred while processing your request.",
        icon: "error",
      });
    }
  };
  const handleReset = () => {
    // setFormData(initialFormData);
    setRequestDate("");
    setSelectedSupplier(null);
    setStore(null);
    setNotes("");
    setSelectedProducts(initialSelectedProducts);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "2rem",
      height: "2.4rem",
    }),
  };

  const supplierOptions = suppliersData?.map((store) => ({
    value: store.ItemId,
    label: store.ItemValue,
  }));
  const storeOptions = storesData?.map((store) => ({
    value: store.ItemId,
    label: store.ItemValue,
  }));

  // Find selected option
  const selectedOption = supplierOptions.find(
    (option) => option.value === selectedSupplier
  );
  const selectedStoreOption = storeOptions.find(
    (option) => option.value === store
  );

  return (
    <div>
      {/*add offcavas */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightPRAdd"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "300px", maxWidth: "50%" }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Add Purchase request</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={handleReset}
          />
        </div>{" "}
        <hr />
        <div className="offcanvas-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="input-blocks">
                  <label className="form-label">Supplier<span className="fw-bold text-danger">*</span></label>
                  <div className="row">
                    <div className="col-lg-12 col-sm-12 col-12">
                      {/* <Select
                                  className="select"
                                  styles={customStyles}
                                  options={suppliersData.map((store) => ({
                                    value: store.ItemId,
                                    label: store.ItemValue,
                                  }))}
                                  onChange={(selectedOption) =>
                                    setSelectedSupplier(selectedOption.value)
                                  }
                                /> */}
                      <Select
                        className="select"
                        styles={customStyles}
                        options={supplierOptions}
                        value={selectedOption || null} // Ensure the value prop receives the full option object
                        onChange={(selectedOption) => {
                          console.log("Selected Option:", selectedOption); // Debugging log
                          setSelectedSupplier(
                            selectedOption ? selectedOption.value : null
                          );
                        }} // Store only the selected ID
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="input-blocks">
                  <label>Date<span className="fw-bold text-danger">*</span></label>
                  <div className="input-groupicon">
                    <input
                      className="form-control"
                      type="date"
                      value={requestDate}
                      onChange={(e) => setRequestDate(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="input-blocks">
                  <label>Store<span className="fw-bold text-danger">*</span></label>
                  {/* <Select
                              className="select"
                              styles={customStyles}
                              options={storesData.map((store) => ({
                                value: store.ItemId,
                                label: store.ItemValue,
                              }))}
                              onChange={(selectedOption) =>
                                setStore(selectedOption.value)
                              }
                            /> */}
                  <Select
                    className="select"
                    styles={customStyles}
                    options={storeOptions}
                    value={selectedStoreOption || null} // Ensure the value prop receives the full option object
                    onChange={(selectedOption) => {
                      console.log("Selected Option:", selectedOption); // Debugging log
                      setStore(selectedOption ? selectedOption.value : null);
                    }} // Store only the selected ID
                  />
                </div>
              </div>
              <div className="col-lg-5 col-sm-6 col-12">
                <div className="input-blocks">
                  <label className="form-label">Notes</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter notes"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-sm-6 col-12">
                <div className="input-blocks">
                  <label>Product </label>
                  <div className="input-groupicon select-code">
                    <Select
                      className="select"
                      styles={customStyles}
                      options={productsDDLData.map((prod) => ({
                        value: prod.Id,
                        label: prod.ProductName,
                      }))}
                      onChange={handleAddProduct}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive no-pagination">
              <table className="table datanew">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Quantity</th>
                    <th>Comment</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedProducts &&
                    selectedProducts.map((prod, index) => (
                      <tr key={prod.Id}>
                        <td>{index + 1}</td>
                        <td>{prod.ProductName}</td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            style={{ width: "10rem" }}
                            value={prod.Quantity}
                            onChange={(e) =>
                              handleQuantityChange(prod.Id, e.target.value)
                            }
                            onWheel={(e) => e.target.blur(e)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter comments"
                            value={prod.Comments}
                            onChange={(e) =>
                              handleCommentsChange(prod.Id, e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <button
                            className="btn btn-light"
                            onClick={() => handleRemoveProduct(prod.Id)}
                          >
                            <i className="fa-regular fa-trash-can text-danger fs-5"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="row mt-4">
              <div className="col-lg-12 text-end">
                <button
                  type="button"
                  className="btn btn-cancel add-cancel me-3"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                  onClick={handleReset}
                  disabled={submitBtnLoading}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-submit add-sale"  disabled={submitBtnLoading}>
                  {submitBtnLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddPurchaseRequest;
